var map = {
	"./Ambulance.png": 1132,
	"./Ask A Doctor.png": 1133,
	"./Blood Cells.png": 1134,
	"./Brain.png": 1135,
	"./Dental.png": 1136,
	"./Depression.png": 1137,
	"./Diagnostics.png": 1138,
	"./Disabled.png": 1139,
	"./Doctor.png": 682,
	"./Ear.png": 1140,
	"./Hospital.png": 1141,
	"./Injection.png": 1142,
	"./Medical Book.png": 1143,
	"./Medical Folder.png": 1144,
	"./Mouth.png": 1145,
	"./Online Claim.png": 1146,
	"./Online Pharmacy.png": 1147,
	"./Optometry.png": 1148,
	"./Pill Bottle.png": 1149,
	"./Podiatry.png": 1150,
	"./Price Tag.png": 1151,
	"./Radiation Theraphy.png": 1152,
	"./Savings.png": 1153,
	"./Symptom List.png": 1154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1131;